import e from "./index13.js";
import t from "./index27.js";
import n from "./index44.js";
import r from "./index45.js";
import i from "./index47.js";
import a from "./index55.js";
import o from "./index89.js";
import s from "./index91.js";
import c from "./index92.js";
import l from "./index93.js";
import u from "./index94.js";
import d from "./index95.js";
import { stringifyTheme as f } from "./index96.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createThemeNoVars.js
function p(p = {}, ...m) {
	let { breakpoints: h, mixins: g = {}, spacing: _, palette: v = {}, transitions: y = {}, typography: b = {}, shape: x, ...S } = p;
	if (p.vars && p.generateThemeVars === void 0) throw Error(process.env.NODE_ENV === "production" ? e(20) : "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature.");
	let C = o(v), w = i(p), T = t(w, {
		mixins: s(w.breakpoints, g),
		palette: C,
		shadows: l.slice(),
		typography: c(C, b),
		transitions: u(y),
		zIndex: { ...d }
	});
	if (T = t(T, S), T = m.reduce((e, n) => t(e, n), T), process.env.NODE_ENV !== "production") {
		let e = [
			"active",
			"checked",
			"completed",
			"disabled",
			"error",
			"expanded",
			"focused",
			"focusVisible",
			"required",
			"selected"
		], t = (t, n) => {
			let r;
			for (r in t) {
				let i = t[r];
				if (e.includes(r) && Object.keys(i).length > 0) {
					if (process.env.NODE_ENV !== "production") {
						let e = a("", r);
						console.error([
							`MUI: The \`${n}\` component increases the CSS specificity of the \`${r}\` internal state.`,
							"You can not override it like this: ",
							JSON.stringify(t, null, 2),
							"",
							`Instead, you need to use the '&.${e}' syntax:`,
							JSON.stringify({ root: { [`&.${e}`]: i } }, null, 2),
							"",
							"https://mui.com/r/state-classes-guide"
						].join("\n"));
					}
					t[r] = {};
				}
			}
		};
		Object.keys(T.components).forEach((e) => {
			let n = T.components[e].styleOverrides;
			n && e.startsWith("Mui") && t(n, e);
		});
	}
	return T.unstable_sxConfig = {
		...n,
		...S?.unstable_sxConfig
	}, T.unstable_sx = function(e) {
		return r({
			sx: e,
			theme: this
		});
	}, T.toRuntimeSource = f, T;
}
//#endregion
export { p as default };

//# sourceMappingURL=index97.js.map